import request from "@src/utils/request";

export interface ClinicSignUpPayload {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  passwordConfirm: string;
  agreedToTerms: boolean;
}

export interface ClinicSignUpClinicPayload {
  clinicName: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  postalCode: string;
  phone: string;
}

export function clinicSignUp(payload: ClinicSignUpPayload) {
  return request().post("/api/v1/clinic-signup/").send(payload);
}

export function createOrMatchClinic(payload: ClinicSignUpClinicPayload) {
  return request().post("/api/v1/clinic-signup/clinic/").send(payload);
}
